import React, { useEffect, useState } from "react";
import { Tab, Tabs } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import AdminDashboard from "./admindashboard";
import Agentinsurance from "./Agentinsurance";
import EmployeeProfile from "./employeeProfile";
import EmpAppointments from "./empAppointments";
import ViewAppointmentsByEmployer from "./viewAppointmentsByEmployer";
import EmployeeFamilyDetails from "./employeeFamilyDetails";
import EmployeeDoctorAppointment from "./employeeDoctorAppointment";
import "./hm-theme.css";

function EmployeeProfileTab() {
  const [activeTab, setActiveTab] = useState('employee-profile');

  useEffect(() => {}, []);

  const role = JSON.parse(localStorage.getItem("data") || "{}").role;

  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">person</i>
                Employee Profile
              </h2>
              <p className="hm-page-subtitle">View and manage your profile, appointments and family details</p>
            </div>
          </div>

          {/* Tab Card */}
          <div className="hm-card">
            <div className="hm-card-body p-0">
              <div className="hm-tabs">
                <Tabs
                  id="employee-profile-tabs"
                  activeKey={activeTab}
                  onSelect={(tab) => setActiveTab(tab)}
                  className="px-3 pt-2"
                >
                  <Tab
                    eventKey="employee-profile"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>badge</i>
                        Profile
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === 'employee-profile' && <EmployeeProfile />}
                    </div>
                  </Tab>

                  <Tab
                    eventKey="lab-appointments"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>biotech</i>
                        Lab Appointments
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === "lab-appointments" && (
                        role === 'ROLE_EMPLOYER'
                          ? <ViewAppointmentsByEmployer />
                          : <EmpAppointments />
                      )}
                    </div>
                  </Tab>

                  <Tab
                    eventKey="doctor-appointments"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>medical_services</i>
                        Doctor Appointments
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === "doctor-appointments" && <EmployeeDoctorAppointment />}
                    </div>
                  </Tab>

                  <Tab
                    eventKey="familyDetails"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>groups</i>
                        Family Details
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === "familyDetails" && <EmployeeFamilyDetails />}
                    </div>
                  </Tab>

                  <Tab
                    eventKey="insurance"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>shield</i>
                        Insurance
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === "insurance" && <Agentinsurance />}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default EmployeeProfileTab;